import DMB_API from './api';

export const categorias_api = {
    getCategoriaName: function () { return DMB_API.get('/api/plate_cat/lsp?id=2', {}, {})
    .then(response => ((response.data.status === 'success') ? response.data.regs : []))
    .catch(error => console.log(error))},

    getCategorias: function (categoria) { return DMB_API.get('/api/plate_cat/lsp?id_commerce='+categoria, {}, {})
    .then(response => {
        //(response.data.status === 'success') ? response.data.regs : [])
            if (response.data.status === 'success') {
                if(response.data.pdf === '') {
                    return ['regs',response.data.regs]
                } else {
                    return ['pdf',response.data.pdf]
                }
            } else {
                return []
            }
        }
    )
    .catch(error => console.log(error))},
}